module.exports = __webpack_public_path__ + "static/5-07becab918837e52ac0fbe0107627f61.jpg";